module.exports = __webpack_public_path__ + "img/link.bdde3044.svg";